export default () => ({
    totalShow: false,

    init() {
        setTimeout(() => {
            this.totalShow = true;            
        }, 3000);
    },
})
